import { createStore } from 'vuex'

export default createStore({
  state: {
    name: 'vue3.0'
  },
  mutations: {
    setTitle(state, payload) {
      state.name = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
